const STORAGE_KEY = "company-open-tabs-v1";

const safeParse = (raw) => {
  if (!raw) return [];
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const loadCompanyOpenTabs = () => {
  try {
    return safeParse(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return [];
  }
};

export const saveCompanyOpenTabs = (tabs) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tabs || []));
  } catch {
    // ignore
  }
};

export const upsertCompanyTab = (tab) => {
  if (!tab || !tab.id) return loadCompanyOpenTabs();
  const current = loadCompanyOpenTabs();
  const next = [
    { ...tab, id: String(tab.id) },
    ...current.filter((t) => String(t.id) !== String(tab.id)),
  ].slice(0, 12);
  saveCompanyOpenTabs(next);
  return next;
};

export const closeCompanyTab = (id) => {
  const current = loadCompanyOpenTabs();
  const next = current.filter((t) => String(t.id) !== String(id));
  saveCompanyOpenTabs(next);
  return next;
};

